jQuery(function ($) {
  let quantity = 1;

  function initMiniCart() {
    $(".plus").off("click");
    $(".minus").off("click");
    $(".add-to-cart").off("click");
    $(".add-to-cart-btn").off("click");
    $(".remove_from_cart_button").off("click");

    $(".mini-cart-minus, .mini-cart-plus").off("click");

    $(".mini-cart-plus").on("click", function () {
      const cart_item_key = $(this).data("cart_item_key");
      updateCartItemQuantity(cart_item_key, "increase");
    });

    $(".mini-cart-minus").on("click", function () {
      const cart_item_key = $(this).data("cart_item_key");
      updateCartItemQuantity(cart_item_key, "decrease");
    });

    $(".plus").on("click", function () {
      quantity++;
      $("#quantity").text(quantity);
    });

    $(".minus").on("click", function () {
      if (quantity > 1) {
        quantity--;
        $("#quantity").text(quantity);
      }
    });

    $(".add-to-cart-btn").on("click", function () {
      const product_id = $(this).data("product-id");
      $.ajax({
        url: ajax_object.ajax_url,
        type: "POST",
        data: {
          action: "add_to_cart_ajax",
          product_id: product_id,
          quantity: quantity,
        },
        success: function (response) {
          updateMiniCart("add-to-cart");
        },
      });
    });

    $(".add-to-cart").on("click", function () {
      const product_id = $(this).data("product-id");
      $.ajax({
        url: ajax_object.ajax_url,
        type: "POST",
        data: {
          action: "add_to_cart_ajax",
          product_id: product_id,
        },
        success: function (response) {
          updateMiniCart("add-to-cart");
        },
      });
    });

    $(".remove_from_cart_button").on("click", function (e) {
      e.preventDefault();
      const cart_item_key = $(this).data("cart_item_key");
      $.ajax({
        url: ajax_object.ajax_url,
        type: "POST",
        data: {
          action: "remove_from_cart_ajax",
          cart_item_key: cart_item_key,
        },
        success: function (response) {
          if (response.success) {
            updateMiniCart("remove-from-cart");
          }
        },
      });
    });
  }

  function updateCartItemQuantity(cart_item_key, action) {
    $.ajax({
      url: ajax_object.ajax_url,
      type: "POST",
      data: {
        action: "update_cart_item_quantity_ajax",
        cart_item_key: cart_item_key,
        update_action: action,
      },
      success: function (response) {
        if (response.success) {
          updateMiniCart();
        } else {
          console.error("Failed to update cart item quantity");
        }
      },
    });
  }

  function updateMiniCart(gotFrom) {
    $.ajax({
      url: ajax_object.ajax_url,
      type: "GET",
      data: {
        action: "get_mini_cart",
      },
      success: function (response) {
        if (response.success) {
          $("#cartBody").html(response.data.mini_cart_html);
          if (gotFrom === "add-to-cart") {
            $("#minicartPopup").addClass("active");
            $("#minicartContent").addClass("active");
          }
          initMiniCart();
        }
      },
    });
  }

  initMiniCart();
});
